// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"ToggleSwitch_toggleSwitch__c2KRk","loading":"ToggleSwitch_loading__Mbgt4","enabled":"ToggleSwitch_enabled__IFm+I"};